module.exports = __webpack_public_path__ + "components/MapControl/svg/Wyciąg narciarski.svg?4734470b";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Wyciąg narciarski.svg
// module id = 2152
// module chunks = 0